import React from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import Image1 from "../../images/prod-menu-img1-resize.png";
import Image2 from "../../images/prod-menu-img2-resize.png";
import Image3 from "../../images/prod-menu-img3-resize.png";
import Image4 from "../../images/prod-menu-img4-resize.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const USCabinet = () => {
  return (
    <>
      <SectionHeader
        title="US Cabinet"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Detail About Vendor"
        content=""
      ></SectionHeader>

      <Container className="aling">
        <Row>
          <Col md={12}>
            <div className="products">
              <Row>
                <Col md={3}>
                  <div className="product-card">
                    <div className="Image">
                      <Link to="/cabinet-product">
                        <img src={Image1} alt="" />
                      </Link>
                    </div>
                    <div className="product-title">
                      <span>Framed Cabinetry</span>
                      <div className="poduct-price">
                        <span>Capital Collection</span>
                      </div>
                    </div>
                    <Link to="/cabinet-product">
                      Learn More
                    </Link>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="product-card">
                    <div className="Image">
                      <Link to="/cabinet-product">
                        <img src={Image2} alt="" />
                      </Link>
                    </div>
                    <div className="product-title">
                      <span>Framed Cabinetry</span>
                      <div className="poduct-price">
                        <span>Capital Impressions Collection</span>
                      </div>
                    </div>
                    <Link to="/cabinet-product">
                      Learn More
                    </Link>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="product-card">
                    <div className="Image">
                      <Link to="/cabinet-product">
                        <img src={Image3} alt="" />
                      </Link>
                    </div>
                    <div className="product-title">
                      <span>Framed Cabinetry</span>
                      <div className="poduct-price">
                        <span>altaeuro collection</span>
                      </div>
                    </div>
                    <Link to="/cabinet-product">
                      Learn More
                    </Link>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="product-card">
                    <div className="Image">
                      <Link to="/cabinet-product">
                        <img src={Image4} alt="" />
                      </Link>
                    </div>
                    <div className="product-title">
                      <span>Framed Cabinetry</span>
                      <div className="poduct-price">
                        <span>Rev-A-Shelf® Accesories</span>
                      </div>
                    </div>
                    <Link to="/cabinet-product">
                      Learn More
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default USCabinet;
